
import { Component, Vue, Watch } from 'vue-property-decorator'

import { Voting } from '../lib/models/Voting'

import BacButton from '../components/BacButton.vue'
import { Http } from '@/lib/utils/Http'

@Component({
  components: {
    BacButton
  }
})
export default class Vote extends Vue {
  private voting: Voting = new Voting()

  private chosenAnswer = -1
  private ip = ''

  mounted () {
    this.loadData()
  }

  async loadData () {
    await this.loadIp()
    await this.loadVote()
    this.voteInLocalStorage()
    if (this.voting.selectedVote !== null && this.voting.selectedVote !== -1) {
      this.chosenAnswer = this.voting.selectedVote
    }
  }

  voteInLocalStorage () {
    const localVotingIp = localStorage.getItem(`vote-${this.voting.id}-ip`)
    if (localVotingIp !== null) {
      this.chosenAnswer = parseInt(localVotingIp)
    }
  }

  async loadIp () {
    const urlParams = new URLSearchParams(window.location.search)
    const voteParam = urlParams.get('vote')
    if (!voteParam) {
      return
    }
    const voteId = parseInt(voteParam)
    if (voteId !== null) {
      this.voting.id = voteId
    }
    const localVotingIp = localStorage.getItem(`vote-${this.voting.id}-ip`)
    if (this.voting.id && localVotingIp !== null) {
      this.ip = localVotingIp
    } else {
      this.ip = await (await Http.request('https://wts.anexia-it.com/index/getIP')).text()
    }
  }

  async loadVote () {
    const urlParams = new URLSearchParams(window.location.search)
    const voteParam = urlParams.get('vote')
    if (voteParam && parseInt(voteParam)) {
      this.voting = await Voting.get(parseInt(voteParam) + '/' + this.ip)
    }
  }

  async vote () {
    await this.voting.vote(this.chosenAnswer, this.ip)
  }

  @Watch('chosenAnswer')
  async onChosenAnswerChange () {
    await this.vote()
    await this.loadVote()
  }
}
